import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { notificationNavigation } from '../../Push Notifications/notificationNavigation';
import { deleteNotifs, PushNotif } from '../../Push Notifications/PushNotificationSlice';
import { Badge, Spinner } from 'reactstrap';
import { ArrowForwardIos } from '@mui/icons-material';
import './WelcomeModal.css';

type Props = {
    tab: number;
    todo: number;
    notifs: PushNotif [];
    onClose: () => void;
}

const WelcomeTabContent = ({ tab, todo, notifs, onClose }: Props) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const loading = useAppSelector(
        (state) => state.todo.loading || state.notifications.deleting
    );

    const handleNavigation = () => {
        navigate('/TodoList');
        onClose();
    };

    const handleNotification = async (item: PushNotif) => {
        console.log('DELETING IDs:', item.id);

        try {
            await notificationNavigation(item, dispatch, navigate);
    
            const result = await dispatch(
                deleteNotifs({ id: item.id })
            );
    
            if (deleteNotifs.fulfilled.match(result)) {
                onClose();
            } else {
                console.error('Failed to delete notification:', result);
            }
        } catch (err) {
            console.error(
                'Failed to navigate from notification:',
                err
            );
        }
    };

    const handleMarkAllRead = async () => {
        if (notifs.length === 0) {
            return;
        }

        const notificationIds = notifs.map(notif => notif.id);

        const result = await dispatch(
            deleteNotifs({ id: notificationIds })
        );

        if (deleteNotifs.fulfilled.match(result)) {
            console.log('ALL NOTIFS DELETED');
        } else {
            console.error('FAILED TO DELETE ALL:', result);
        }
    };

    if (tab === 1) {
        return (
            <div className='scrollable-container'>
                {todo > 0 ? (
                    <div
                        onClick={handleNavigation}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            backgroundColor: '#f9f9f9',
                            padding: 10,
                            marginBottom: 2,
                            borderRadius: 5,
                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)',
                            width: '100%',
                            cursor: 'pointer',
                        }}
                    >
                        <div>
                            <Badge 
                                pill
                                color={'danger'}
                            >
                                {
                                    loading 
                                    ? <Spinner color="white" style={{ width: '10px', height: '10px', }}/>
                                    : todo
                                }
                            </Badge>
                            <span>To-Do List</span>
                        </div>
                        <div>
                            <ArrowForwardIos 
                                sx={{ color: '#f1b434' }}
                            />
                        </div>
                    </div>
                ) : (
                    <span>No new tasks</span>
                )}
            </div>
        )
    }

    if (tab === 2) {
        return (
            <div
                className='scrollable-container'
            >
                {notifs.length === 0 ? (
                    <span>No new messages</span>

                ) : (
                    <div>
                        <div
                            style={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 1000,
                            paddingBlockEnd: '1px',
                        }}
                        className='bg-white'
                        >
                            <div
                                style={{
                                    justifySelf: 'flex-end',
                                    backgroundColor: '#f1b434',
                                    borderRadius: 10,
                                    width: '110px',
                                    padding: 5,
                                    marginBottom: 10,
                                    cursor: 'pointer',
                                }}
                                onClick={() => handleMarkAllRead()}
                            >
                                <span>Mark All Read</span>
                            </div>
                        </div>
                        {notifs.map((item) => (
                            <div
                                key={item.id}
                                onClick={() => handleNotification(item)}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'flex-start',
                                    alignItems: 'center',
                                    backgroundColor: '#f9f9f9',
                                    padding: 10,
                                    marginBottom: 2,
                                    borderRadius: 5,
                                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)',
                                    width: '100%',
                                    cursor: 'pointer',
                                }}
                            >
                                <div 
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flex: 1,
                                        minWidth: 0,
                                        paddingRight: 10,
                                    }}
                                >
                                    <span>{item.title}</span>
                                    <span>{item.message}</span>
                                </div>
                                <div style={{ alignItems: 'flex-end' }}>
                                    <ArrowForwardIos 
                                        sx={{ color: '#f1b434' }}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                )
            }
            </div>
        )
    }

    return null;
};

export default WelcomeTabContent;